import { render, staticRenderFns } from "./HeaderBp.vue?vue&type=template&id=4051c7e1&"
import script from "./HeaderBp.vue?vue&type=script&lang=js&"
export * from "./HeaderBp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports